var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-box"},[_vm._v("\n    "+_vm._s(_vm.Id)+"\n    "),_c('img',{attrs:{"src":require("../static/logo.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }